import {TranslocoService} from '@ngneat/transloco';
import {CsvError, CsvErrorList} from '../../model/import-csv/csv-error';
import {PropertiesErrorsInterface} from './properties-errors.interface';

type Constructor<T extends PropertiesErrorsInterface> = new(...args: any[]) => T;

export class CsvErrors<T extends PropertiesErrorsInterface, U> {
  protected propertiesErrors: T;
  public errors: CsvErrorList;

  constructor(
    protected readonly i18n: TranslocoService, private ctor: Constructor<T>
  ) {
    this.propertiesErrors = new this.ctor(this.i18n);
    this.errors = {};
  }

  public required(object: U, objectProperty: string, errorProperty: string = objectProperty): boolean {
    if (object[objectProperty] == null || object[objectProperty].toString().trim() == '') {
      this.addCsvMachineError(errorProperty, {
        message: 'isRequired',
        params: {
          field: this.propertiesErrors.getTranslation(errorProperty).toLowerCase(),
          value: object[objectProperty],
        }
      });
      return false;
    }
    return true;
  }

  public minLength(object: U, property: string, minLength: number): void {
    if (object[property] == null || object[property].length < minLength) {
      this.addCsvMachineError(property, {
        message: 'noMinLength',
        params: {
          field: this.propertiesErrors.getTranslation(property).toLowerCase(),
          value: object[property],
        }
      });
    }
    return null;
  }

  public maxLength(object: U, property: string, maxLength: number): void {
    if (object[property] == null || object[property].length > maxLength) {
      this.addCsvMachineError(property, {
        message: 'exceedsMaxLength',
        params: {
          field: this.propertiesErrors.getTranslation(property).toLowerCase(),
          value: object[property]
        }
      });
    }
    return null;
  }

  public noSpecialCharacters(object: U, property: string): void {
    const nameRegexp: RegExp = /[!@#$%^&*()+=\[\]{};':"\\|,.<>\/?]/;
    if (object[property] == null || nameRegexp.test(object[property])) {
      this.addCsvMachineError(property, {
        message: 'hasSpecialChars',
        params: {
          field: this.propertiesErrors.getTranslation(property).toLowerCase(),
          value: object[property],
        }
      });
    }
    return null;
  }

  public noWhitespaces(object: U, property: string): void {
    const nameRegexp: RegExp = /[\s]/;
    if (object[property] == null || nameRegexp.test(object[property])) {
      this.addCsvMachineError(property, {
        message: 'hasWhitespaces',
        params: {
          field: this.propertiesErrors.getTranslation(property).toLowerCase(),
          value: object[property]
        }
      });
    }
    return null;
  }

  public validJson(object: U, property: string): void {
    let jsonData: JSON | null;
    try {
      jsonData = JSON.parse(object[property]);
    } catch (e) {
      jsonData = null;
    }
    if (jsonData == null) {
      this.addCsvMachineError(property, {
        message: 'noValidJson',
        params: {
          field: this.propertiesErrors.getTranslation(property).toLowerCase(),
          value: object[property],
        }
      });
    }
    return null;
  }

  protected addCsvMachineError(property: any, csvError: CsvError): void {
    if (!this.errors.hasOwnProperty(property)) this.errors[property] = [];
    this.errors[property].push(csvError);
  }

}
